module.exports = __webpack_public_path__ + "img/cloud2.a8f727ea.png";